import React, {useId} from 'react';
import cn from 'classnames';

import CheckMark from 'shared/ui/CheckMark/CheckMark';

import {ITariffAdvantageState} from '../../../lib/tariffAdvantages';

import styles from './AdvantagesList.module.scss';

interface IAdvantagesListProps {
    title: string,
    items: ITariffAdvantageState[],
    variant: 'offered' | 'included',
}

const AdvantagesList: React.FC<IAdvantagesListProps> = ({title, items, variant}) => {
    const titleId = useId();
    const isIncluded = 'included' === variant;

    if (!items.length) {
        return null;
    }

    return (
        <>
            <div className={styles.title} id={titleId}>{title}</div>
            <ul className={styles.list} aria-labelledby={titleId}>
                {items.map(({key, label}) => (
                    <li className={cn(styles.item, !isIncluded && styles.offered)} key={key}>
                        {isIncluded && <CheckMark/>}
                        <span>{label}</span>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default AdvantagesList;
